import * as S from './ConfirmationPopup.styles'
import useScreenSize from '../../hooks/useScreenSize'
import { GrowTransition } from 'components/Transitions/Transitions'

type Props = {
  title: string
  approveText: string
  onApprove: () => void
  dismissText: string
  onDismiss: () => void
}

function ConfirmationPopup({
  title,
  approveText,
  onApprove,
  dismissText,
  onDismiss,
}: Props) {
  const isMediumScreen = useScreenSize('md')
  const Content = (
    <S.Container data-testid="confirmation-popup">
      <S.Title>{title}</S.Title>
      <S.Cta onClick={onApprove} data-testid="confirmation-popup-approve">
        {approveText}
      </S.Cta>
      <S.Cta
        onClick={onDismiss}
        variant="light"
        data-testid="confirmation-popup-dismiss"
      >
        {dismissText}
      </S.Cta>
    </S.Container>
  )

  if (isMediumScreen) {
    return (
      <S.Dialog open onClose={onDismiss} TransitionComponent={GrowTransition}>
        <S.CloseButton onClick={onDismiss} />
        {Content}
      </S.Dialog>
    )
  } else {
    return (
      <S.BottomDrawer
        anchor="bottom"
        transitionDuration={400}
        open
        onClose={onDismiss}
      >
        {Content}
      </S.BottomDrawer>
    )
  }
}

export default ConfirmationPopup
